/**
 * The dates a report covers (DASH-005, RPT-001/002; TMMRSL-0073): one muted caption line under the
 * report's header, e.g. "Sep 1 – 30, 2026". Its dates are the response's `from` / `to` where the
 * response carries them, else the range the picker requested; for Current period, which sends no
 * dates, it is the preset's label: the console never computes "current" itself. No response carries
 * an as-of time, so none is shown.
 */
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCivilRange } from '@/i18n/useCivilRange';

export interface ReportScopeProps {
  from: string | null | undefined;
  to: string | null | undefined;
}

export function ReportScope({ from, to }: ReportScopeProps) {
  const { t } = useTranslation();
  const civilRange = useCivilRange(t('statements.unavailable'));
  return (
    <Typography variant="body2" component="p" sx={{ color: 'text.secondary' }}>
      {from ? civilRange(from, to) : t('period.current')}
    </Typography>
  );
}
